import React, { Component } from "react";
import phoneImg from "../image/theme/phone-call.png";
import locationImg from "../image/theme/location.png";
//import hours from "../image/dentaldesigns/wall-clock.png";
// import chatImg from "../image/theme/chat.png";
// import Whatsapp from "../image/theme/whatsapp.png";
// import Facebook from "../image/theme/facebook-sm.png";
// import Pinterest from "../image/theme/pinterest-sm.png";
// import instagram from "../image/theme/instagram-sm.png";
// import twitter from "../image/theme/twitter-12.png";
// import youtube from "../image/theme/youtube-sm.png";
import InnerHTML from "dangerously-set-html-content";
import Whatsapp from "../adminManagement/pharmaAdAproval/whatsapp";
import ChatBoat from "../dashboard/chatBoat";
import { apiCalling } from "../apiService";

export default class footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hospitalData: [],
      hospitalDataLength: 0,
      footerDetails: [],
      footerData: [],
      footerTiming: window.sessionStorage.getItem("hospital_working_time"),
      hospitalTotalLocationCount: window.sessionStorage.getItem(
        "hospitalLocationCount"
      ),
    };
  }
  componentDidMount() {
    const hospitalData = JSON.parse(
      window.sessionStorage.getItem("footerhospitalData")
    );
    const footerData = JSON.parse(window.sessionStorage.getItem("footerData"));
    if (footerData) {
      this.setState({ footerData: footerData });
    }
    if (hospitalData) {
      this.setState({ hospitalData: hospitalData });
      this.setState({ hospitalDataLength: hospitalData.length });
    } else {
    }
  }
  componentWillMount() {
    const footerList = {
      method: "POST",
      body: JSON.stringify({
        functionName: "getFooterLinks",
        groupHospitalAdminId: window.sessionStorage.getItem(
          "groupHospitalAdminId"
        ),
      }),
    };

    apiCalling(footerList).then((data) => {
      if (data.success === "1") {
        this.setState({ footerDetails: data.footerLinkData });
      }
    });
  }
  render() {
    const urlPath = window.location.origin.toString();
    return (
      <div class="metalFooter" id="footerMain">
        <div class="footerTop">
          {this.state.hospitalData.map((obj) => {
            var location =
              obj.googleAddressPin === ""
                ? obj.latitude + "," + obj.longitude
                : obj.googleAddressPin;
            return (
              // <div class="footerContainer container">
              <div
                class={
                  this.state.hospitalData.length === 1
                    ? "footerContainer footerContainer1"
                    : this.state.hospitalData.length === 2
                    ? "footerContainer footerContainer2"
                    : this.state.hospitalData.length === 3
                    ? "footerContainer footerContainer3"
                    : "footerContainer footerContainer2"
                }
              >
                <div class="footerMenuList">
                  <div class="footerTitle">Location</div>
                  <div class="addressSec footerListSub mb-0">
                    <img
                      src={locationImg}
                      alt=""
                      width="15"
                      className="mr-2 addressSecImg"
                    />
                    <span className="footerListSubSpan">
                      <strong>{obj.hospitalName}</strong>
                      {obj.address}, &nbsp;
                      {obj.cityName}, &nbsp;
                      {obj.stateName}, &nbsp;
                      {obj.zipCode}
                    </span>
                    <br></br>

                    <div className="footerListSub">
                      <img
                        src={phoneImg}
                        alt=""
                        width="15"
                        className="mr-2 addressSecImg"
                      />
                      <span className="footerListSubSpan">{obj.phone}</span>
                    </div>
                    {/* <div className="footerListSub">
                <img src={chatImg} alt="" width="15" className="mr-2 addressSecImg"/> 
                <span  className="footerListSubSpan">{obj.emailId} </span>
              </div> */}
                  </div>
                </div>
                <div class="footerMenuList">
                  <div className="footerListSub mapDiv">
                    <iframe
                      src={
                        "https://maps.google.com/maps?q=" +
                        location +
                        "&ll=" +
                        obj.latitude +
                        "," +
                        obj.longitude +
                        "&z=15&output=embed"
                      }
                      width="100%"
                      height="200"
                      frameborder="0"
                      allowfullscreen=""
                    ></iframe>
                  </div>
                </div>
              </div>
            );
          })}
         
          {parseInt(this.state.hospitalTotalLocationCount) > 4 && (
            <div>
              <a href="/moreLocations">View More Locations</a>
            </div>
          )}
        </div>
        <div class="footerContainerBottom">
          <div class="container footerContainerBottomSub">
            {this.state.footerTiming !== "" ? (
              <div class="footerMenuList">
                <div class="footerTitle">Hours</div>
                <ul class="">
                  <li>
                    <span>
                      <InnerHTML html={this.state.footerTiming} />
                    </span>
                  </li>
                  <li>{/* <span>Sunday : Closed</span> */}</li>
                </ul>
              </div>
            ) : (
              ""
            )}
            <div className="footerMenuList">
              <div class="footerTitle">Contact Email</div>
              {window.sessionStorage.getItem("contact_emailId") !== "" ? (
                <ul class="">
                  <li>
                    <span>
                      {window.sessionStorage.getItem("contact_emailId")}
                    </span>
                  </li>
                </ul>
              ) : (
                ""
              )}
            </div>
            
            {this.state.footerData.length > 0 ? (
              <div class="footerSocial footerMenuList">
                {this.state.footerData.map((obj) => {
                  return (
                    <div class="footerSocialSub">
                      {obj.name === "Instagram" && (
                        <a href={obj.url} title="Instagram" target="_blank">
                          <i class="fa fa-instagram" aria-hidden="true"></i>
                        </a>
                      )}
                      {obj.name === "Twitter" && (
                        <a href={obj.url} title="Twitter" target="_blank">
                          <i class="fa fa-twitter" aria-hidden="true"></i>
                        </a>
                      )}
                      {obj.name === "Youtube" && (
                        <a href={obj.url} title="Youtube" target="_blank">
                          <i class="fa fa-youtube" aria-hidden="true"></i>
                        </a>
                      )}
                      {obj.name === "Facebook" && (
                        <a href={obj.url} title="Facebook" target="_blank">
                          <i class="fa fa-facebook" aria-hidden="true"></i>
                        </a>
                      )}
                      {obj.name === "Pinterest" && (
                        <a href={obj.url} title="Pinterest" target="_blank">
                          <i class="fa fa-pinterest" aria-hidden="true"></i>
                        </a>
                      )}
                      {/* {obj.name === "Whatsapp" && (
                        <a
                          href={"tel:" + obj.content}
                          title={"Whatsapp:" + obj.content}
                          target="_blank"
                        >
                          <i class="fa fa-whatsapp" aria-hidden="true"></i>
                        </a>
                      )} */}
                      {obj.name === "Whatsapp" && (
                        <Whatsapp path={obj?.url}></Whatsapp>
                        // <a href={obj.url} title={"Whatsapp"} target="_blank">
                        //   <i class="fa fa-whatsapp" aria-hidden="true"></i>
                        // </a>
                      )}

                      {obj.name === "Linkedin" && (
                        <a href={obj.url} title={"LinkedIn"} target="_blank">
                          <i class="fa fa-linkedin" aria-hidden="true"></i>
                        </a>
                      )}
                    </div>
                  );
                })}
              </div>
            ) : (
              ""
            )}
          </div>
          <ChatBoat/>
        </div>

        <div class="footerBottom footerBottomLink">
          <div className="container">
            <div className="footerBottomCenter">
              <a href={(urlPath, "/termsConditions")}>Terms and Conditions</a>{" "}
              <span className="px-1 m-0">|</span>
              <a href={(urlPath, "/privacyPolicy")}>Privacy Policy</a>
            </div>
            <div className="footerBottomRight">
              Copyright © {new Date().getFullYear()}{" "}
              {window.sessionStorage.getItem("siteName")}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
